
import React , { Component } from 'react';

class ContactUs extends Component{

    render(){
        return(
            <div>
                联系我们
            </div>

        );

    }
}

export default ContactUs;